import { render, staticRenderFns } from "./AddMarketModal.vue?vue&type=template&id=0e28f540&scoped=true"
import script from "./AddMarketModal.vue?vue&type=script&lang=js"
export * from "./AddMarketModal.vue?vue&type=script&lang=js"
import style0 from "./AddMarketModal.vue?vue&type=style&index=0&id=0e28f540&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e28f540",
  null
  
)

export default component.exports